<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App',
  methods: {
    createPageTitle: function (to) {
      // タイトルを設定
      if (to.meta.title) {
        let setTitle = to.meta.title + ' | マイナビ新卒紹介'
        document.title = setTitle
      } else {
        document.title = 'マイナビ新卒紹介'
      }
    },
    addBodyClass: function (to) {
      jQuery(function ($) {
        // 初期化
        $('body').attr('class', '')
        if (to.matched.length > 0) {
          to.matched.forEach(function (matchObj) {
            let bodyClass = matchObj.meta.bodyClass
            if (bodyClass) {
              let addClassList = bodyClass.split(' ')
              addClassList.forEach(function (addClass) {
                if (!$('body').hasClass(addClass)) {
                  $('body').addClass(addClass)
                }
              })
            }
          })
        }
      })
    }
  },
  mounted: function () {
    let to = this.$route
    this.createPageTitle(to)
    this.addBodyClass(to)
  },
  watch: {
    '$route' (to, from) {
      this.createPageTitle(to)
      this.addBodyClass(to)
    }
  }
}
</script>
